import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import * as common from './common';
import { AuthRole } from '@/src/constants/shared';

export interface LSEMessage {
  text: common.NullableString;
  url?: common.NullableString;
  header?: common.NullableString;
  level?: common.NullableString;
  audience?: AuthRole[];
  notificationType?: 'lse' | 'global-notification';
  id?: common.NullableString;
}

@jsonObject
export class LSEMessage {
  @jsonMember(common.NullableStringValue)
  text: common.NullableString = null;
  @jsonMember(common.NullableStringValue)
  url?: common.NullableString | undefined = undefined;
  @jsonMember(common.NullableStringValue)
  header?: string | null;
  @jsonMember(common.NullableStringValue)
  level?: string | null;
  @jsonArrayMember(common.NullableStringValue)
  audience?: AuthRole[];
  @jsonMember(common.NullableStringValue)
  id?: string | null;
  @jsonMember(common.NullableStringValue)
  notificationType?: 'lse' | 'global-notification';
}

@jsonObject
export class LSEResponse {
  @jsonMember(LSEMessage)
  message?: LSEMessage = undefined;
}

export interface CreateLSERequest {
  readonly message: LSEMessage;
}

export interface UpdateLSERequest {
  readonly message: LSEMessage;
  readonly notificationType: 'lse' | 'global-notification';
  readonly id?: string;
}
